import { StoreSchema } from '../../types/store'
import { createSelector } from 'reselect'

export const selectSettingsState = (store: StoreSchema) => store.settings

export const selectAllProductsSettings = (store: StoreSchema) =>
    store.settings.productsSettings

export const selectProductGeneralSettings = (guid: string) =>
    createSelector(
        [selectAllProductsSettings],
        (allProductsSettings) => allProductsSettings[guid]?.generalSettings
    )

export const selectProductGeneralSettingsDefault = (guid: string) =>
    createSelector(
        [selectAllProductsSettings],
        (allProductsSettings) =>
            allProductsSettings[guid]?.generalSettingsDefault
    )

export const selectProductBackupSettings = (guid: string) =>
    createSelector(
        [selectAllProductsSettings],
        (allProductsSettings) => allProductsSettings[guid]?.backupSettings
    )

export const selectProductBackupSettingsDefault = (guid: string) =>
    createSelector(
        [selectAllProductsSettings],
        (allProductsSettings) =>
            allProductsSettings[guid]?.backupSettingsDefault
    )
